<template>
  <v-layout>
    <v-flex xs12 sm12 md12 lg12>
      <span v-if="node.meta.type === 'title'">
        <name-input
          :node="node"
          :editMode="false"
          :createMode="true"
          @validation="$emit('validation', $event)"
          :selectedRecord="selectedRecord"
          :isRoot="false"
        ></name-input>
      </span>
      <span v-else-if="node.meta.type === 'text'">
        <text-input
          :node="node"
          :editMode="false"
          :createMode="true"
          @validation="$emit('validation', $event)"
          :selectedRecord="selectedRecord"
          :isRoot="false"
        ></text-input>
      </span>
      <span v-else-if="node.meta.type === 'numeric'">
        <numeric
          :node="node"
          :editMode="false"
          :createMode="true"
          @validation="$emit('validation', $event)"
          :selectedRecord="selectedRecord"
          :isRoot="false"
        ></numeric>
      </span>
      <span
        v-else-if="
          node.meta.type === 'numeric-array' ||
            node.meta.type === 'numeric array'
        "
      >
        <numeric-array
          :node="node"
          :editMode="false"
          :createMode="true"
          @validation="$emit('validation', $event)"
          :selectedRecord="selectedRecord"
          :isRoot="false"
        ></numeric-array>
      </span>
      <span v-else-if="node.meta.type === 'text-array'">
        <text-array
          :node="node"
          :editMode="false"
          :createMode="true"
          @validation="$emit('validation', $event)"
          :selectedRecord="selectedRecord"
          :isRoot="false"
        ></text-array>
      </span>
      <span
        v-else-if="
          node.meta.type === 'numeric-scale' ||
            node.meta.type === 'numeric scale'
        "
      >
        <numeric-scale
          :node="node"
          :editMode="false"
          :createMode="true"
          @validation="$emit('validation', $event)"
          :selectedRecord="selectedRecord"
          :isRoot="false"
        ></numeric-scale>
      </span>
      <span v-else-if="node.meta.type === 'boolean'">
        <boolean
          :node="node"
          :editMode="false"
          :createMode="true"
          @validation="$emit('validation', $event)"
          :selectedRecord="selectedRecord"
          :isRoot="false"
        ></boolean>
      </span>
      <span
        v-else-if="
          node.meta.type === 'value-list' || node.meta.type === 'value list'
        "
      >
        <SingleValueList
          :node="node"
          :editMode="false"
          :createMode="true"
          @validation="$emit('validation', $event)"
          :selectedRecord="selectedRecord"
          :isRoot="false"
        ></SingleValueList>
      </span>
      <span
        v-else-if="
          node.meta.type === 'multiple-value-list' ||
            node.meta.type === 'multiple value list'
        "
      >
        <MultipleValueList
          :node="node"
          :editMode="false"
          :createMode="true"
          @validation="$emit('validation', $event)"
          :selectedRecord="selectedRecord"
          :isRoot="false"
        ></MultipleValueList>
      </span>
      <span v-else-if="node.meta.type === 'np-date'">
        <Date
          :node="node"
          :editMode="false"
          :createMode="true"
          @validation="$emit('validation', $event)"
          :selectedRecord="selectedRecord"
          :isRoot="false"
        ></Date>
      </span>
      <span v-else-if="node.meta.type === 'np-text'">
        <nptext
          :node="node"
          :editMode="false"
          :createMode="true"
          @validation="$emit('validation', $event)"
          :selectedRecord="selectedRecord"
          :isRoot="false"
        ></nptext>
      </span>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TextInput from "./form-types/TextInput";
import NameInput from "./form-types/NameInput";
import Numeric from "./form-types/Numeric";
import NumericArray from "./form-types/NumericArray";
import TextArray from "./form-types/TextArray";
import NumericScale from "./form-types/NumericScale";
import Boolean from "./form-types/Boolean";
import SingleValueList from "./form-types/SingleValueList";
import MultipleValueList from "./form-types/MultipleValueList";
import Date from "./form-types/Date";
import nptext from "./non-periodic-form-types/np-TextInput";

export default {
  name: "TypeCreator",
  props: {
    node: Object,
    selectedRecord: Object
  },
  components: {
    TextInput,
    NameInput,
    Numeric,
    NumericArray,
    TextArray,
    NumericScale,
    Boolean,
    SingleValueList,
    MultipleValueList,
    Date,
    nptext
  },

  mounted() {},
  computed: {},
  data() {
    return {};
  },

  methods: {}
};
</script>

<style>
.layout {
  margin: 0;
}
</style>
